export default "../media/left_arrow.45b1b68c9083a65bee6756ba8c0a41df.svg";